import React from 'react';
import EmptyState from '../EmptyState';

import Card from '../Card';
import { EditButton, DotsVertIcon } from '~/components/EditButton/styles';

import { Container, Title, Subtitle } from './style';

const CardList = (props) => {
  const defaultProps = {
    items: [],
    isAdmin: false,
    emptyStateText: 'Lista vazia',
    onSelect: () => console.log('Missing on select'),
    onEdit: (event) => {
      event.stopPropagation();
      console.log('Missing on edit');
    },
    cardSize: {
      height: 150,
      minWidth: 300,
      maxWidth: 410,
    },
  };

  const {
    items,
    emptyStateText,
    onSelect,
    onEdit,
    cardSize,
    isAdmin,
    ...rest
  } = {
    ...defaultProps,
    ...props,
  };

  return items.length > 0 ? (
    <Container>
      {items.map((item) => {
        return (
          <Card
            {...rest}
            key={item.id}
            onClick={() => onSelect(item)}
            backgroundImage={item.backgroundImage}
            size={cardSize}
          >
            {isAdmin ? (
              <EditButton onClick={(event) => onEdit(event, item)}>
                <DotsVertIcon />
              </EditButton>
            ) : null}
            <Title>{item.title}</Title>
            <Subtitle>{item.subtitle && item.subtitle}</Subtitle>
          </Card>
        );
      })}
    </Container>
  ) : (
    <EmptyState text={emptyStateText} />
  );
};

export default CardList;
